// @ts-nocheck
import {useMutation, useQueryClient} from "@tanstack/react-query";
import {addFavoriteGameService} from "../../services/games/miniGames/favoriteGames.service";

const useAddFavoriteGame = () => {
  const query = useQueryClient();
  const {isPending, isSuccess, mutate, error, isError} = useMutation({
    mutationKey: ["addFavoriteGame"],
    mutationFn: addFavoriteGameService,
    onSuccess: _data => {
      query.invalidateQueries(["listFavoriteGames"]);
    },
  });

  return {
    isSuccessAdd: isSuccess,
    isErrorAdd: isError,
    errorAdd: error,
    isPendingAdd: isPending,
    addFavoriteGame: mutate,
  };
};

export default useAddFavoriteGame;
